export const AppLogoPNG = require('./logo/app-logo/app-logo.png');
export const AppLogoAndNamePNG = require('./logo/app-logo/logo-and-name-horizontal.png');
